// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__qqoDt","signatureBlock":"Footer_signatureBlock__3aYJT","signature":"Footer_signature__wGnZR"};